import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import { Link } from 'react-router-dom'

const _ = require('underscore')

const DrawingsContainer = ({ match, drawings }) => {
  const isLoading = drawings === undefined

  const drawingElems = []
  _.each(drawings, (drawing, key) => {
    drawingElems.push(
      <Link key={key} to={`/drawings/${key}`}>
        <img alt="" src={drawing.imageUrl} className="drawing-thumb" />
      </Link>,
    )
  })

  return (
    <div className="drawings-container">
      <h1>Pick a drawing</h1>
      {isLoading && <div>Loading</div>}
      {drawingElems}
    </div>
  )
}

export default compose(
  firebaseConnect([
    { path: '/drawings' }, // object notation
  ]),
  connect((state) => {
    return {
      drawings: state.firebase.data.drawings,
    }
  }),
)(DrawingsContainer)



// WEBPACK FOOTER //
// ./src/containers/drawingsContainer.js